import Button from '@Components/Buttons/Button'
import React, { useContext } from 'react'
import WorkStore from '@App/stores/work/work-store'
import Navigation from '@App/navigation'
import { dismissWork } from '@App/api/routes/work'
import { RegistrationHistoryTabName } from '@App/enum/registration-history-tab-name'
import { RegistrationStatus } from '@App/enum/registration-status'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import { useNavigate } from 'react-router'
import { observer } from 'mobx-react'
import clsx from 'clsx'

interface NeedsAttentionActionsProps {
    work: WorkModel
}

const NeedsAttentionActions = ({ work }: NeedsAttentionActionsProps) => {
    const navigate = useNavigate()
    const { rightsholderStore, workStore, registrationHistoryStore, wizardFlowStore, userStore } =
        useContext<RootStore>(StoresContext)

    const handleResubmit = () => {
        if (!work.id) {
            return
        }
        workStore.setOriginalSubmissionId(work.id)
        const mappedWork = WorkStore.mapResponseToWorkObject(work)
        mappedWork.originalSubmissionId = mappedWork.id
        mappedWork.id = null
        mappedWork.createdDate = null
        mappedWork.registrationHistoryStatus = null
        mappedWork.isComplete = false
        mappedWork.registrationHistoryIndicator = null
        mappedWork.registrationHistoryDate = null
        mappedWork.updateDate = null
        workStore.setCreatedWorkId(undefined)
        workStore.setWorkDraftToLocal(mappedWork)
        wizardFlowStore.setCurrentIndex(5)
        navigate(Navigation.rightholder.createWork.wizard.review(rightsholderStore.currentRightsholderId))
    }

    const handleDismiss = async () => {
        if (!work.id) {
            return
        }
        await dismissWork(rightsholderStore.currentRightsholderId, work.id)
        await registrationHistoryStore.registrationHistoryTabs
            .get(RegistrationHistoryTabName.NeedsAttention)
            ?.searchRegistrationHistory({ status: RegistrationStatus.needs_attention, defaultFilters: ['processing'] })
    }

    return (
        <div className={clsx('needs-attention-actions')} onClick={(e) => e.preventDefault()}>
            <Button
                mainColor
                type="secondary"
                onClick={handleDismiss}
                disabled={userStore.isInternal}
                submitType="button"
            >
                Dismiss
            </Button>
            <Button
                className="resubmit-button"
                mainColor
                type="primary"
                onClick={handleResubmit}
                disabled={userStore.isInternal}
                submitType="button"
            >
                Resubmit
            </Button>
        </div>
    )
}

export default observer(NeedsAttentionActions)
